import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

/** `number` — held as text while typing; `visibleValues` submits it as a number (submitSchema). */
export default function NumberField(props) {
	const { field } = props;
	return (
		<MuiTextField
			{...textFieldProps(props)}
			type="number"
			inputProps={{ min: field.min, max: field.max, inputMode: "decimal" }}
		/>
	);
}
